import React from 'react';
import PropTypes from 'prop-types';
import { ArticlePage } from '@/components/Articles';
import * as env from '@/env';
import { allArticles, prioritizeArticles } from '@/utilities/articles';

export default function Articles({ articles, featured, numPages }) {
  return (
    <ArticlePage articles={articles} featured={featured} numPages={numPages} />
  );
}

Articles.propTypes = {
  articles: PropTypes.array.isRequired,
  featured: PropTypes.array.isRequired,
  numPages: PropTypes.number.isRequired
};


export async function getStaticProps({ locale }) {
  const numFeatured = env.NUM_FEATURED_ARTICLES;
  const pageSize = env.CONTENT_STACK_PAGINATE_AFTER;

  const allArticlesForLocale = prioritizeArticles(allArticles()[locale]);
  const count = allArticlesForLocale.length;
  const numPages = Math.ceil((count - numFeatured) / pageSize);

  const featured = allArticlesForLocale?.slice(0, numFeatured);

  const articles = allArticlesForLocale?.slice(numFeatured, numFeatured + pageSize);

  return {
    props: {
      articles,
      featured,
      numPages
    },
  };
}
